import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const navigate = useNavigate();
  const { user, logoutUser } = useAuth();

  const handleLogout = () => {
    logoutUser();
    navigate('/');
  };

  return (
    <nav style={styles.nav}>
      <div style={styles.container}>
        <Link to="/" style={styles.logo}>Sytch</Link>
        <div style={styles.links}>
          <Link to="/search" style={styles.link}>Find a Ride</Link>
          {user ? (
            <>
              <Link to="/post-trip" style={styles.link}>Offer a Ride</Link>
              <Link to={`/profile/${user.id}`} style={styles.link}>
                {user.first_name}
              </Link>
              <button style={styles.logoutBtn} onClick={handleLogout}>
                Sign Out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" style={styles.link}>Sign In</Link>
              <Link to="/register" style={styles.joinBtn}>Join Free</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

const styles = {
  nav: {
    background: '#1a1a2e',
    padding: '0 20px',
    position: 'sticky',
    top: 0,
    zIndex: 100,
    boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
  },
  container: {
    maxWidth: '1000px',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '64px',
  },
  logo: {
    color: '#4fc3f7',
    fontSize: '24px',
    fontWeight: 'bold',
    textDecoration: 'none',
    fontFamily: 'Arial, sans-serif',
  },
  links: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
  },
  link: {
    color: '#b0bec5',
    textDecoration: 'none',
    fontSize: '15px',
    fontFamily: 'Arial, sans-serif',
  },
  joinBtn: {
    background: '#4fc3f7',
    color: '#1a1a2e',
    padding: '8px 20px',
    borderRadius: '8px',
    textDecoration: 'none',
    fontSize: '15px',
    fontWeight: 'bold',
    fontFamily: 'Arial, sans-serif',
  },
  logoutBtn: {
    background: 'none',
    border: '1px solid #b0bec5',
    color: '#b0bec5',
    padding: '8px 16px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '15px',
    fontFamily: 'Arial, sans-serif',
  },
};

export default Navbar;